export const WEBPERFORMANCE_CORE_SCENE = 'webPerformanceCoreScene'
export const WEBPERFORMANCE_INDICATOR = 'webPerformanceIndicator'
export const WEBPERFORMANCE_ALPHA = 'webPerformanceAlpha'

const powerGoPerfix = 'pg'
export const WEB_PERFORMANCE_CORE_SCENE_MAP = {
  workbench: `${powerGoPerfix}_workbench`
}
